import BaseModelAPI from '../BaseModelAPI';

export default class PutAway extends BaseModelAPI {
	static entity = 'putaway';
	static entityName = 'putaway';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.putAwayDate = '';
		this.putAwayTypeId = '';
		this.putAwayType = {};
		this.controlCardId = '';
		this.controlCard = {};
		this.controlCardNumber = '';
		this.rackId = '';
		this.rack = {};
		this.remark = '';
		this.approvalId = '';
		this.approval = {};
		this.isLocked = false;
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.isScanned = '';
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}


	static async checkputawaylocked(this_) {
		return this_.$http.get(`${this.entityName}/checkputawaylocked`)
			.then(async function (response) {
				return response.data;
			})
			.catch(function (error) {
				var stringError = 'Gagal memeriksa locking putaway!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
			});
	}

	static async scanApproval(this_, id, qrCode) {
		return await this_.$http.get(`${this.entityName}/scanapproval?id${id}&qrcode=${qrCode}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				this_.toast({ message: 'Gagal melakukan scan approval!', title: 'Error', variant: 'danger' });
				throw error;
			})
			.catch(function (error) {
				var stringError = 'Gagal melakukan scan approval!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw stringError;
			});
	}

	static async scanRack(this_, id, qrCode) {
		return this_.$http.get(`${this.entityName}/scanrack/${id}?qrcode=${qrCode}`)
			.then(async function (response) {
				if (response != null) {
					return response.data;
				}
				this_.toast({ message: 'Gagal memproses Scan Rack!', title: 'Error', variant: 'danger' });
				throw error;
			})
			.catch(function (error) {
				var stringError = 'Gagal memproses Scan Rack!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw stringError;
			});
	}

}